document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initMarquee();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initMarquee() {
  var tracks = document.querySelectorAll('.mt-marquee-track');
  if (!tracks.length) return;
  tracks.forEach(function (track) {
    if (track.dataset.mtDup) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtDup = '1';
  });
}
